import { useEffect, useRef, useState } from "react";
import { Box, MenuItem, Paper, TextField, Typography } from "@mui/material";
import { normalizeSearch as normalize } from "../../Partials/searchNormalize";

const Combobox = ({ options, value, onChange, placeholder, disabled, validate }) => {
  const selected = options.find(o => o.value === value);
  const [query, setQuery] = useState(selected?.label ?? "");
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const commitOrResetRef = useRef(() => {});

  useEffect(() => {
    setQuery(selected?.label ?? "");
  }, [selected?.label]);

  const filtered = query.trim() ? options.filter(o => normalize(o.label).includes(normalize(query))) : options;
  const validationError = validate && query.trim() ? validate(query) : null;

  commitOrResetRef.current = () => {
    setOpen(false);
    const exact = options.find(o => normalize(o.label) === normalize(query));
    if (exact) {
      onChange(exact.value);
    } else if (filtered.length === 1) {
      onChange(filtered[0].value);
    } else {
      setQuery(selected?.label ?? "");
    }
  };

  useEffect(() => {
    const handler = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        commitOrResetRef.current();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const select = opt => {
    onChange(opt.value);
    setOpen(false);
  };

  return (
    <Box
      ref={containerRef}
      sx={{ position: "relative" }}
    >
      <TextField
        size="small"
        variant="outlined"
        hiddenLabel
        value={query}
        disabled={disabled}
        placeholder={placeholder}
        onChange={e => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onKeyDown={e => {
          if (e.key === "Enter") {
            commitOrResetRef.current();
            e.preventDefault();
          }
          if (e.key === "Escape") {
            setOpen(false);
            setQuery(selected?.label ?? "");
          }
        }}
        error={!!validationError}
        sx={{
          width: 120,
          "& .MuiOutlinedInput-input": {
            textAlign: "center",
            py: 1,
          },
        }}
      />
      {validationError && (
        <Typography
          variant="caption"
          color="error"
          sx={{ display: "block", whiteSpace: "nowrap", mt: 0.25 }}
        >
          {validationError}
        </Typography>
      )}
      {open && !validationError && (
        <Paper
          sx={{
            position: "absolute",
            left: 0,
            top: "100%",
            zIndex: 10,
            mt: 0.5,
            maxHeight: 192,
            minWidth: "100%",
            overflow: "auto",
          }}
        >
          {filtered.length > 0 ? (
            filtered.map(opt => (
              <MenuItem
                key={opt.value}
                selected={opt.value === value}
                onMouseDown={() => select(opt)}
                sx={{ justifyContent: "center" }}
              >
                {opt.label}
              </MenuItem>
            ))
          ) : (
            <MenuItem
              disabled
              sx={{ justifyContent: "center" }}
            >
              Няма резултати
            </MenuItem>
          )}
        </Paper>
      )}
    </Box>
  );
};

export default Combobox;
